import { mapState } from 'vuex';
import externalServicesMixin from '@/common/mixins/externalServicesMixin';

export default {
  computed: {
    ...mapState('loggedAccount', ['account', 'clinics', 'accountClinic']),
  },
  mixins: [externalServicesMixin],
  methods: {
    checkClinicFeature(featureName, clinicAccount = null) {
      const account = clinicAccount || this.accountClinic;
      return !!account?.features?.find(feature => feature.name === featureName);
    },
    checkMultipleClinicFeatures(featureName) {
      const allClinicsFeatures = this.clinics.map(clinic => clinic.features).flat();
      return !!allClinicsFeatures?.find(feature => feature.name === featureName);
    },
    checkFeatureByClinicId(featureName, clinicId) {
      const findClinic = this.clinics.find(clinic => clinic.id === clinicId);
      return findClinic?.features?.find(feature => feature.name === featureName);
    },
    checkFeatureAllowance(perm) {
      const multipleClinicRoles = ['PROVIDER', 'CLINIC_ADMIN'];

      switch (perm) {
        case 'messaging': {
          if (multipleClinicRoles.includes(this.account?.role)) return this.checkMultipleClinicFeatures('messaging');
          return this.checkClinicFeature('messaging');
        }
        default: {
          return false;
        }
      }
    },
  },
};
